import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { IsSmallScreen, MasterPages } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions, getPermissions } from "../../commonFunctions/PermissionManger";
export const TaskList: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getTaskPermission;
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    const source = {
        url: "tasks/search",
        page: 1,
        pageSize: 10,
        filter: [
        ],
        sort: [{
            "field": "UpdatedAt",
            "direction": "desc"
        }],
    };

    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/task/edit/${row?.id}`)
        }

    };
    const columns: IColumns[] = [
        {
            header: "Task",
            fieldName: "taskName",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Task Date",
            fieldName: "customDate",
            type: 'date'
        },
        {
            header: "Task type",
            fieldName: "taskType",
            type: 'default'
        },
        {
            header: "Priority",
            fieldName: "priority",
            type: 'default'
        },

        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];

    const mobColumns: IOrderColumns[] = [
        {
            header: "Task",
            fieldName: "taskName",
            tooltip: true,
            type: 'default',
            labelSx:{fontWeight:'bold'}
        },
        {
            header: "Task type",
            fieldName: "taskType",
            type: 'default'
        },
        {
            header: "Priority",
            fieldName: "priority",
            type: 'default',
            sm:4,
        },
        {
            header: "Date",
            fieldName: "customDate",
            type: 'date',
            labelSx:{marginLeft:2},
            sm:8,
            isBoderRadious:true
        },
        
       

        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleClick = () => {
        navigate('/task/create')
    }
    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="taskMainListGrid"
                        title="Tasks"
                        columns={columns}
                        source={source}
                        addButton={{ label: 'New', color: 'secondary', }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {isMobile &&
                        <WSMobileDataGridAdvanced title={'Tasks'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleClick} columns={mobColumns} id="taskMainListGrid" source={source} />
                    }
                </Grid>
                    : <PermissionDenied />
                }
            </Grid>
        </>
    )
})